export default {
  FETCH_UPDATE: 'FETCH_UPDATE',
  FETCH_STATUS: 'FETCH_STATUS',
  FETCH_MESSAGES: 'FETCH_MESSAGES',
  FETCH_MESSAGES_DETAIL: 'FETCH_MESSAGES_DETAIL',
  FETCH_MESSAGES_ATTACHMENTS: 'FETCH_MESSAGES_ATTACHMENTS',
  SET_CURRENT_MESSAGE_PREVIEW: 'SET_CURRENT_MESSAGE_PREVIEW',
}
